import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import React, { useEffect, useRef, useState } from 'react';
import Button from '@mui/material/Button';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { styled, Paper, TextField, MenuItem } from '@mui/material';
import STATES, { STATE }   from 'js/constants/states';
import { isAU } from 'js/constants/crux';
import Reports from 'js/constants/reports';
import Commons from 'js/helpers/Commons';
import {
    CLEAR_ADDRESS_COLLECTIVE,
    clearSuggestion,
    getAddressCollective,
    getSuggestions,
} from 'js/actions/clapi';
import StyledTooltip from 'js/components/common/styledMUI/StyledTooltip';
import Colors from 'js/constants/colors';
import SuggestionTypes  from 'js/constants/suggestionTypes';
import { getAssetDomainOld } from 'js/constants/assets';
import LDHelper from 'js/helpers/LaunchDarklyHelper';
import { UNSUBSCRIBED } from 'js/constants/tooltipText';
import CruxSplitButtonDropdown from 'js/components/common/CruxSplitButtonDropdown';
import CruxButton from 'js/components/common/styledMUI/CruxButton';
import {
    SuggestHeaderContainer,
    StyledAutoComplete,
    StyledOption,
    StyledNoRecentSearchOption,
    SuggestionIcon,
    SuggestionHeader,
    SuggestionHeaderText,
    StyledOptionText,
} from '../styledComponents/searchbarStyles';
import MUITooltip from 'js/components/common/MUITooltip';
import useLocationSearch from 'js/hooks/multiLocality/useLocationSearch';
import { REPORT_TYPES } from 'js/helpers/Localization';
import { routeCodes } from 'js/constants/routes';
import ReportModal from 'js/components/reports/ReportModal';
import ReportHelper  from 'js/helpers/report/ReportHelper';

import { EXACT_ADDRESS_PARAM } from 'js/constants/batchSearch/batchSearch';
import { goToSignatureReport } from 'js/actions/signature';
import ValuationReport from 'js/components/reports/ValuationReport';
import RentalEstimateReport from 'js/components/reports/RentalEstimateReport';
import Clapi from 'js/api/clapi';
import { EQUITY_REPORT, VALUATION } from 'js/constants/propertyDetail';
import DialogMessage from 'js/components/common/modals/DialogMessage';
import { cruxLoader, cruxUnloader } from 'js/actions/crux';
import { trackEvent } from 'js/actions/segment';
import Segment from 'js/helpers/Segment';
import Flags from 'js/constants/featureFlags';
import SEGMENT from 'js/constants/segment';
import FeatureFlags from 'js/constants/featureFlags';
import { validPropertyTypesForEquityReport } from '../../../../constants/propertyTypes';

const {
    ADDRESS, LOCALITY, SUBURB,
} = SuggestionTypes;

const SUGGESTION_LIMIT = 10;

export const ReportSearchBarContainer = styled('div')({
    display: 'flex',
    width: '100%',
});

const StyledSplitDropdown = styled(CruxSplitButtonDropdown)({
    marginRight: '8px',
    whiteSpace: 'nowrap',
    '& .MuiButtonGroup-root': {
        minWidth: '166px',
        '& .MuiButtonBase-root': {
            height: '40px',
            fontSize: '14px',
            '&:first-of-type': {
                width: 'max-content',
            },
        },
    },
    '& .MuiList-root': {
        width: '222px',
    }
});

const ReportAddressLocalitySearchBar = styled('div')({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
});

const REPORT_SIGNATURE_MAPPING = {
    cmaReport: Reports.SIGNATURE_REPORT_TYPES.CMA,
    rentalCmaReport: Reports.SIGNATURE_REPORT_TYPES.RENTAL,
    soi: Reports.SIGNATURE_REPORT_TYPES.SOI,
};

const _REPORT_TYPES = JSON.parse(JSON.stringify(REPORT_TYPES));

export const ReportAddressSearch = ({
    suggestions,
    location,
    dispatch,
    route,
    entryPoint,
    address,
    history,
    usrDetail,
    propertyInvestmentReportFlag,
    applicationDomain,
    proposalFlag,
    equityCalculatorReportFlag,
 }) => {
    const dropdown = useRef({});
    const [options, setOptions] = useState([]);
    const [optionSelected, setOptionSelected] = useState(null);
    const [isSearchBarActive, setIsSearchBarActive] = useState(false);
    const [reportType, setReportType] = useState(null);
    const [suggestionTypes, setSuggestionTypes] = useState([]);
    const [openReportModal, setOpenReportModal] = useState(false);
    const [dialogMessage, setDialogMessage] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [addressName, setAddressName] = useState(null);
    const [propertyId, setPropertyId] = useState(null);

    const reportRoles = ReportHelper.getRolesWithExcludedRoles(usrDetail);

    const valuationTrigger = useRef(null);
    const rentalTrigger = useRef(null);

    const {
        isHistoric,
        isOpen,
        setIsOpen,
        getOptionLabel,
        keyword,
        setKeyword,
    } = useLocationSearch({ location, route, dispatch });

    const trackHtmlReportGeneration = (reportType) => {
        dispatch(trackEvent(Segment.generateReport({
            pageContext: route.pageContext,
            entryPoint,
            propertyId: optionSelected?.suggestionId,
            reportType,
            reportFormat: SEGMENT.EVENT_PROPERTIES.HTML,
        })));
    };

    useEffect(() => {
      setOptions(suggestions?.length > 0 ? suggestions : []);
    }, [suggestions]);

    useEffect(() => {
        const reportGenerator = {
            onePageReport: toggleReportModal,
            digitalReport: toggleReportModal,
            propertyReport: toggleReportModal,
            titleReport: toggleReportModal,
            propertyInvestment: toggleReportModal,
            cmaReport: redirectToSignature,
            rentalCmaReport: redirectToSignature,
            soi: redirectToSignature,
            valuationEstimate: handleValuationReport,
            rentalEstimate: handleValuationReport,
            proposal: handleProposalsRedirect,
            equityCalculatorReport: handleEquityReport,
        };
        const reportTracker = {
            equityCalculatorReport: () => trackHtmlReportGeneration(REPORT_TYPES.equityCalculatorReport.label)
        };

        if (!address) return; // do nothing when address collective cleared
        if (address?.metadata?.totalElements > 1) {
            dispatch({
                type: CLEAR_ADDRESS_COLLECTIVE,
            });
            history.push({
                pathname: routeCodes
                    .SEARCH_RESULT
                    .path(optionSelected?.suggestionType, optionSelected?.suggestion),
                state: {
                    suggestion: [{ ...optionSelected, suggestionType: EXACT_ADDRESS_PARAM }],
                    addressCollective: true,
                    entryPoint: entryPoint,
                    isActiveProperty: true,
                },
            });
        } else if (!!reportGenerator[reportType?.value]) {
            reportGenerator[reportType?.value]();
            // Track report generation for specific report types
            if (reportTracker[reportType?.value]) {
                reportTracker[reportType?.value]();
            }
        }
    }, [address]);

    useEffect(() => {
        return () => {
            dispatch(clearSuggestion());
        };
    }, []);

    useEffect(() => {
        if (isAU) {
            handleFeatureFlag(REPORT_TYPES.propertyInvestment.value, propertyInvestmentReportFlag);
        }
    }, [propertyInvestmentReportFlag]);

    useEffect(() => {
        if (isAU) {
            handleFeatureFlag(REPORT_TYPES.proposal.value, proposalFlag);
        }
    }, [proposalFlag]);

    useEffect(() => {
        handleFeatureFlag(REPORT_TYPES.equityCalculatorReport.value, equityCalculatorReportFlag);
    }, [equityCalculatorReportFlag]);

    useEffect(() => {
        return () => {
            dispatch(clearSuggestion());
        };
    }, []);

    const handleEquityReport = () => {
        const showEquityReport = validPropertyTypesForEquityReport.includes(address?.data[0]?.type?.toLowerCase());
        if (showEquityReport) {
            toggleReportModal();
        } else {
            setErrorMsg(EQUITY_REPORT.EQUITY_REPORT_UNAVAILABLE);
            setDialogMessage(true);
            resetReport();
        }
    };

    const handleValuationReport = () => {
        const params = {
            'valuationEstimate': {
                valuationError: VALUATION.VALUATION_ESTIMATE_UNAVAILABLE,
                avmCall: () => Clapi
                    .getIntellivalValuationAvm(address?.data[0]?.id),
                fsd: (response) => response?.fsd,
                lowValuationConfidence: `${VALUATION.VALUATION_ESTIMATE_UNAVAILABLE} ${VALUATION.CONFIDENCE_TOO_LOW}`,
                trigger: valuationTrigger,
                fsdThreshold: 25,
            },
            'rentalEstimate': {
                valuationError: VALUATION.RENTAL_ESTIMATE_UNAVAILABLE,
                avmCall: () => Clapi
                    .getRentalAvm(address?.data[0]?.id),
                fsd: (response) => response?.rentalAvmDetail?.rentalAvmEstimateFsdScore,
                lowValuationConfidence: `${VALUATION.RENTAL_ESTIMATE_UNAVAILABLE} ${VALUATION.CONFIDENCE_TOO_LOW}`,
                trigger: rentalTrigger,
                fsdThreshold: 31, // increased this so we don't change logic at line 271; fsd > 30 = low confidence; line 271 also handles valuation estimate data
            }
        }

        const valuation = params[reportType?.value];
        let valuationError = valuation.valuationError;

        dispatch(cruxLoader());
        setPropertyId(optionSelected?.suggestionId);
        valuation.avmCall()
            .then((response) => {
                const fsd = valuation.fsd(response);
                if (fsd > 0 && fsd < valuation.fsdThreshold) {
                    valuationError = null;
                } else if (fsd >= valuation.fsdThreshold) {
                    valuationError = valuation.lowValuationConfidence;
                }
            })
            .finally(() => {
                dispatch(cruxUnloader());
                if (valuationError) {
                    setErrorMsg(valuationError);
                    setDialogMessage(true);
                } else {
                    valuation.trigger?.current?.click();
                }
                resetReport();
            });
    };

    const handleProposalsRedirect = () => {
        const proposalUrl = `${applicationDomain?.rpProposals}?link=${JSON.stringify({
            page: 'createProposal',
            corelogicPropertyId: optionSelected?.suggestionId,
        })}`;

        trackHtmlReportGeneration(SEGMENT.EVENT_PROPERTIES.PROPOSAL);
        window.open(proposalUrl, '_blank');
        resetReport();
    }

    const redirectToSignature = () => {
        dispatch(goToSignatureReport(optionSelected?.suggestionId,
            REPORT_SIGNATURE_MAPPING[reportType.value],
            null,
            entryPoint,
            route.pageContext));
        resetReport();
    };

    const handleFeatureFlag = (key, flag) => {
        const _flag = flag && flag.toLowerCase();
        if (Object.keys(_REPORT_TYPES).includes(key)) {
            if (_flag === 'false') {
                delete _REPORT_TYPES[key];
            } else if (_flag === 'true') {
                _REPORT_TYPES[key].entitlements = '';
            }
        }
    };

    const onInputChange = (event, val) => {
        setKeyword(val);
        const isStateSearch = STATES.includes(val.toUpperCase());
        const LIMIT = isAU && isStateSearch ? 2 : 3;
        if (optionSelected) {
            setOptionSelected(null);
        }
        if (val.length < LIMIT || Commons.hasBackSlash(val)) {
            dispatch(clearSuggestion());
            if (!val.length) {
                // Reset selected suggestion if all chips were deleted.
                setOptionSelected(null);
            }
        } else {
            dispatch(getSuggestions({
                keyword: val,
                suggestionTypes,
                includeHistoric: isHistoric,
                limit: SUGGESTION_LIMIT,
                withDetails: reportType === _REPORT_TYPES.suburbStats,
            }));
        }
    }

    const onChange = (e, value) => {
        // Prevents value being selected if it is not part of the options
        if (typeof value !== 'string') {
            setOptionSelected(value);
        }
    };

    const renderOptions = (props, option, { inputValue }) => {
        const { suggestionType } = option;

        const suggestion = getOptionLabel(option);
        const matches = match(suggestion, Commons.removeComma(inputValue), { insideWords: true });
        const parts = parse(suggestion, matches);
        const _suggestionType = suggestionType === LOCALITY ? SUBURB : ADDRESS;
        const OptionComponent = suggestionType ? StyledOption : StyledNoRecentSearchOption;
        const formattedSuggestion = Commons.formatPipeSeparatedAddress(suggestion);
        return (
            <OptionComponent {...props}>
                {
                    _suggestionType &&
                        <StyledTooltip
                            title={_suggestionType}
                            arrow
                        >
                            <SuggestionIcon
                                className="img-responsive"
                                src={encodeURI(getAssetDomainOld(`${suggestionType}.svg`))}
                                alt={`${suggestionType}-icon`}
                            />
                        </StyledTooltip>
                }
                <div style={{ minWidth: 300, display: 'flow-root' }}>
                    {
                        suggestions.length > 0 ? (
                            parts.map((part, index) => {
                                const formattedPartText = Commons
                                    .formatPipeSeparatedAddress(part.text);
                                const isTextBold = part.highlight && suggestionType;
                                return (
                                    <StyledOptionText
                                        key={index}
                                        title={formattedPartText}
                                        style={{
                                            fontWeight: isTextBold ? 700 : 400,
                                            overflow: part.highlight ? 'inherit' : 'hidden',
                                        }}
                                    >
                                        {formattedPartText}
                                    </StyledOptionText>
                                );
                            })
                        ) : (
                            <StyledOptionText
                                key={`${props.id}-${formattedSuggestion}`}
                                title={formattedSuggestion}
                            >
                                {formattedSuggestion}
                            </StyledOptionText>
                        )
                    }
                </div>
            </OptionComponent>
        );
    };

    const renderContainer = (props) => {
        if (!options.length || !React.Children.toArray(props.children).at(-1)) {
            return null;
        }
        return (
            <Paper
                {...props}
                onMouseDown={event => event.preventDefault()}
                sx={{ marginTop: '5px' }}
                data-testid="multi-locality-suggestions"
            >
                <SuggestHeaderContainer>
                    <SuggestionHeader>
                        <SuggestionHeaderText>SUGGESTIONS</SuggestionHeaderText>
                    </SuggestionHeader>
                </SuggestHeaderContainer>
                {props.children}
            </Paper>
        );
    };

    const resetReport = () => {
        setOptionSelected('');
        dispatch({
            type: CLEAR_ADDRESS_COLLECTIVE,
        });
    };

    const closeReportModal = () => {
        if (!openReportModal) return;
        setOpenReportModal(false);
        resetReport();
    };

    const toggleReportModal = () => {
        setOpenReportModal(!openReportModal);
        closeReportModal();
    };

    const createReport = () => {
        if (reportType === _REPORT_TYPES.suburbReport) {
            toggleReportModal();
        } else if (reportType === _REPORT_TYPES.suburbStats) {
            dispatch(trackEvent(Segment.suburbStatisticReport({
                pageContext: route.pageContext,
                objectContext: optionSelected?.suggestion,
                entryPoint,
            })))
            window
                .open(routeCodes
                    .SUBURB_STATS_REPORT
                    .path(
                        optionSelected?.suggestion,
                        optionSelected?.localityId,
                        optionSelected?.lgaIds.toString().split(',').join(' '),
                    ))
            resetReport();
        }
        setAddressName(optionSelected?.suggestion);
        // Should only handle addresses for collective search
        if (suggestionTypes[0] === ADDRESS) {
            dispatch(getAddressCollective({
                suggestion: optionSelected.suggestion,
                suggestionType: EXACT_ADDRESS_PARAM,
            }, false));
        }
    };

    const onReportTypeChange = (key) => {
        if (suggestions.length) {
            dispatch(clearSuggestion());
        }
        setOptionSelected(null);
        setKeyword('');
        const reportTypeSelected = _REPORT_TYPES[key];
        dropdown.current.close();
        setReportType(reportTypeSelected);
        setSuggestionTypes(reportTypeSelected?.suggestionType || [ADDRESS, SUBURB]);
    };

    const getSuggestionLabel = () => {
        const suggestLabels = {
            locality: 'Search for a suburb',
            address: 'Search for an address',
            selectReport: 'Select a report to begin',
        };

        return suggestionTypes.length
            ? suggestLabels[suggestionTypes[0]]
            : suggestLabels.selectReport;
    };

    const filterOptions = (options) => {
      const filteredOptions = options.filter(option =>
        option.suggestionType !== 'address' || option.suggestionId
      );
      if (reportType === _REPORT_TYPES.soi) {
          return filteredOptions.filter(opt => opt?.suggestion?.split(' ').includes(STATE.VIC.toUpperCase()));
      }
      return filteredOptions;
    };

    return (
        <ReportAddressLocalitySearchBar data-testid="multi-locality-search">
            <ReportSearchBarContainer>
                <StyledSplitDropdown
                    className="crux-dropdown"
                    label={reportType?.label || 'Select Report'}
                    testId="report-search-dropdown"
                    width="auto"
                    ref={dropdown}
                >
                    {
                        Object.keys(_REPORT_TYPES).map((key) => {
                            const { entitlements, label, value } = _REPORT_TYPES[key];
                            const isEntitled = ReportHelper.hasEntitlementInReportRoles(entitlements, reportRoles);
                            return (
                                <MUITooltip
                                    key={label}
                                    title={!isEntitled ? UNSUBSCRIBED : ''}
                                    placement="right"
                                    arrow
                                    sx={{ marginLeft: '-18px !important'}}
                                >
                                    <div>
                                        <MenuItem
                                            key={value}
                                            disabled={!isEntitled}
                                            onClick={() => onReportTypeChange(key)}
                                            selected={reportType?.label === label}
                                            sx={{
                                                color: Colors.BLACK_60_OPAQUE,
                                                fontSize: '14px',
                                                '&.Mui-selected': {
                                                    color: Colors.BLACK_87_OPAQUE,
                                                    backgroundColor: 'white',
                                                    '&:hover': { backgroundColor: 'white' },
                                                },
                                            }}
                                        >
                                            {label}
                                        </MenuItem>
                                    </div>
                                </MUITooltip>
                            );
                        })
                    }

                </StyledSplitDropdown>
                <StyledAutoComplete
                    sx={{
                        minWidth: 586,
                    }}
                    className="form-input-search-field"
                    filterOptions={filterOptions}
                    key={`autocomplete-${location?.state?.addressCollective ? location.key : ''}`}
                    value={optionSelected}
                    inputValue={keyword}
                    disabled={!suggestionTypes.length}
                    disableClearable
                    freeSolo
                    disablePortal
                    autoHighlight
                    onInputChange={onInputChange}
                    onChange={onChange}
                    open={isOpen}
                    options={options}
                    popupIcon={null}
                    onClose={(e, r) => r !== 'toggleInput' && setIsOpen(false)}
                    isSearchBarActive={isSearchBarActive}
                    onOpen={() => setIsOpen(true)}
                    minWidth={585}
                    id="crux-report-search"
                    getOptionLabel={(option) => option.suggestion || option.searchString || ''}
                    renderOption={renderOptions}
                    PaperComponent={renderContainer}
                    renderInput={
                        (params) => (
                            <div className="autocomplete-render-input">
                                <TextField
                                    {...params}
                                    onFocus={() => setIsSearchBarActive(true)}
                                    onBlur={() => setIsSearchBarActive(false)}
                                    placeholder={getSuggestionLabel()}
                                    color="primary"
                                />
                            </div>
                        )
                    }
                />
                <CruxButton
                    colors={{
                        font: Colors.WHITE,
                        backgroundColor: Colors.PRIMARY.MAIN,
                    }}
                    opacity="1"
                    sx={{
                        height: 40,
                    }}
                    onClick={createReport}
                    disabled={!optionSelected}
                >
                    Create Report
                </CruxButton>
            </ReportSearchBarContainer>
           <ReportModal open={openReportModal} onClose={toggleReportModal}>
               {
                   (() => {
                       const modalConfig = ReportHelper.getHomePageModalConfig({
                           suggestions,
                           address,
                           optionSelected,
                           route,
                           entryPoint,
                           toggleReportModal,
                           dispatch,
                       });
                       const key = Object.keys(modalConfig).find(
                           k => reportType === _REPORT_TYPES[k]
                       );
                       if (!key) return null;
                       const { component: Component, props } = modalConfig[key];
                       return <Component {...props} />;
                   })()
               }
           </ReportModal>
            <ValuationReport
                propertyAddress={addressName}
                propertyId={propertyId}
                trigger={<Button sx={{display: 'none'}} ref={valuationTrigger} />}
                pageContext={route.pageContext}
                entryPoint={entryPoint}
                dispatch={dispatch}
            />
            <RentalEstimateReport
                trigger={<Button sx={{display: 'none'}} ref={rentalTrigger} />}
                propertyAddress={addressName}
                propertyId={propertyId}
                pageContext={route.pageContext}
                entryPoint={entryPoint}
                dispatch={dispatch}
            />
            <DialogMessage
                id="report-dialog-message"
                open={dialogMessage}
                onClose={() => setDialogMessage(false)}
                message={errorMsg}
            />
        </ReportAddressLocalitySearchBar>
    );
};

ReportAddressSearch.propTypes = {
    styles: PropTypes.object,
    slas: PropTypes.object,
    route: PropTypes.object.isRequired,
    entryPoint: PropTypes.string.isRequired,
    isHistoricVisible: PropTypes.bool,
    isHeader: PropTypes.bool,
    usrDetail: PropTypes.object,
    suggestions: PropTypes.array,
    includeHistoric: PropTypes.bool,
    location: PropTypes.object,
    history: PropTypes.object,
    dispatch: PropTypes.func,
    handler: PropTypes.object,
    proposalFlag: PropTypes.string,
    propertyInvestmentReportFlag: PropTypes.string,
}

export default connect(state => ({
    usrDetail: state.clapi.get('usrDetail'),
    suggestions: state.clapi.get('suggestions'),
    handler: state.msg.get('handler'),
    includeHistoric: isAU && LDHelper.featureFlagSelector(state, FeatureFlags.HISTORIC, false),
    address: state.rapid.get('address'),
    proposalFlag: LDHelper.featureFlagSelector(state, Flags.RP_PROPOSALS_REPORT, false),
    applicationDomain: state.config.get('applicationDomain'),
    propertyInvestmentReportFlag: LDHelper.featureFlagSelector(state, FeatureFlags.PROPERTY_INVESTMENT_REPORT, false),
    equityCalculatorReportFlag: LDHelper.featureFlagSelector(state, FeatureFlags.EQUITY_REPORT, false),
}))(withRouter(ReportAddressSearch));
